export default __webpack_public_path__ + "static/media/step_img_6.cb3af53c.png";